 <template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            
            <strong>Rider Travel Tracking</strong>
          
          </div>

            <div id="overlay" >
             <div class="loader"></div>
           </div>
          <!-- Filter  -->
      <b-row>
      <b-col md="12">
        <b-col md="12">  
        <b-row class="form-group">    
                <b-col sm="3" >
                 
              <b-form-group label="DeliveryAgent">
                 <b-form-select class="form-control input" v-model="deliveryagentid" name="deliveryagentid" >
                        <option :value="selected" >--Select--</option>
                        <option v-for="agent in agentmaster" v-bind:value="agent.deliveryagentmasterid">{{ agent.deliveryagentfirstname}} {{ agent.deliveryagentlastname}}-{{ agent.deliveryagentmasterid}}</option>
                  </b-form-select>
               </b-form-group>
                </b-col> 
                <b-col sm="3">
                         
                <b-form-group label="From Date"   >
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>

              </b-col>
               <b-col sm="3">
               
                <b-form-group label="To Date"   >
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>

              </b-col>
              <b-col sm="2" >     
               <b-button type="submit" size="md" variant="primary" @click="travelTrackinglist(pageNum)" style="margin-top: 19%;"> Search</b-button>&nbsp;
               <b-button type="submit" size="md" variant="danger" @click="clearTable(pageNum)" style="margin-top: 19%;"> Clear</b-button>
              </b-col>
            </b-row>
            </b-col>
          </b-col>     
        </b-row>

         <!-- Filter End -->
   
         <!-- Pending Listing   -->
           <b-col sm="12" class="text-right">

                

               <p > <b>Total Records :<span style="color:red;margin-right: 10px;">{{ totalRows }}</span></b> </p>
              </b-col> 
          <b-col sm="12">
            <b-table responsive show-empty  :busy="isBusy" :items="travelitems" :fields="travelfields"  :current-page="currentPage" :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" :bordered="bordered" >

                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>


              
             


          </b-table>
        </b-col>
         <b-col md="6" class="my-1" v-if="totalRows>0">
             <paginate
   
            :page-count="noofpages"
            :page-range="10"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'">
  </paginate>
          </b-col>
          <!-- <b-col md="6" class="my-1" >
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col> -->

        <!-- Listing End -->
       
      

        </b-card>
      </b-col>
    </b-row>
    </b-row>    
  </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue'
export default {
  data: function() {
    return {
     travelitems:[],
      travelfields: [
      { key: 'rider_id', label: 'Rider Id', sortable: true, sortDirection: 'desc' },
      { key: 'username', label: 'Rider Name', sortable: true, sortDirection: 'desc' },
      { key: 'journeydate', label: 'Journey Date', sortable: true, sortDirection: 'desc' },
      { key: 'distance', label: 'Total distance (KM)', sortable: true, sortDirection: 'desc' },

      
        
      ],
        selected:'',
        isBusy: false,
        
        Pickup:'',
        email:'',

        selectDateFrom:new Date(),
        selectDateTo:new Date(),
        bordered: true,
        
        currentPage: 1,
        // perPage:  10,
        pageOptions: [5, 10, 15,20],
        sortBy: null,
        isCheckAll: false,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        agentmaster:[],
        
        deliveryagentid:'',
        totalRows:0,
        pageNum:1,
        noofpages:'',
        pageOptions: [5, 10, 15],
        perPage:20,
        sortBy: true,
          
    };
  },
  created: function() {

    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.displaydata();
    this.travelTrackinglist(this.pageNum);
  },
   methods: { 
  // Function for DeliveryAgent dropdown
    clickCallback (pageNum)
       {

        this.travelTrackinglist(pageNum);
    },
     displaydata: function () {
         var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
        hub_id:`${userInfo.pickuplocationmasterid}`,
        is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          this.agentmaster = result.body;
          
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },

    // end
    // Pending Petrol Bill Listing
   travelTrackinglist:function(page){
           
       var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // console.log("this.deliveryagentid",typeof this.deliveryagentid);
        var deliveryagentid=(this.deliveryagentid!='')? this.deliveryagentid:"";
       var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
      // this.selected_status=status;
     
      this.isBusy = true;
         
     
      const obj = {
    
        riderId:deliveryagentid,
        startdate:fromdate,
        enddate:formatdateto,
        pageno: page,
       
      };
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAllRidersDiatanceTravelListingApi`,obj)
        .then(result => {
          this.isBusy=false;
          if (result.data.returnmsg == "Successful") {

            this.travelitems  = result.body.returnvalue[0].responsedata;
            // this.imgpath=result.body.returnvalue;
           
            this.totalRows = result.body.returnvalue[0].totalcount
            this.noofpages=parseInt(this.totalRows)/20;
           
           this.noofpages=Math.ceil( this.noofpages);
          
          } else {
             this.travelitems=[];
             this.totalRows=0;
             this.noofpages='';
          }
        })
        .catch(ex => {
          console.log("error-----", ex);
        });

   },
  clearTable:function(){
     this.selectDateFrom=new Date();
     this.selectDateTo=new Date();
    this.travelTrackinglist(this.pageNum)
  },
  
   
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");

    }, 
   

    

   
  
    
  }
};
</script>

<style lang="css">

</style>
